export default __webpack_public_path__ + "static/media/Martiyers12.55643b24.jpg";